import { Authorization, SharedProps, User } from '@/types'
import { Head, router, usePage } from '@inertiajs/react'
import { ActionIcon, Button, Group, Paper, Stack, Table, Text, Title } from '@mantine/core'
import { IconPlus, IconShieldLock, IconTrash } from '@tabler/icons-react'

export default function AuthorizationsIndexPage({
  authorizations,
}: {
  authorizations: (Authorization & { user: User })[]
}) {
  const { props } = usePage<SharedProps>()
  const { current_organization } = props

  const handleCreateAuthorization = () => {
    router.visit(`/organizations/${current_organization?.slug}/authorizations/new`)
  }

  const roleOptions = [
    { value: 'admin', label: 'Administrateur' },
    { value: 'atelier', label: 'Atelier' },
    { value: 'accueil', label: 'Accueil' },
    { value: 'courier', label: 'Coursier' },
  ]

  return (
    <>
      <Head title={`Autorisations - ${current_organization?.name}`} />

      <Stack>
        <Group justify="space-between" align="center">
          <Title>Autorisations</Title>
          <Button leftSection={<IconPlus size={18} />} onClick={handleCreateAuthorization}>
            Nouvelle autorisation
          </Button>
        </Group>

        {authorizations.length > 0 ? (
          <Paper withBorder radius="md" p="md">
            <Table.ScrollContainer minWidth={400}>
              <Table highlightOnHover>
                <Table.Thead>
                  <Table.Tr>
                    <Table.Th>Nom</Table.Th>
                    <Table.Th>Email</Table.Th>
                    <Table.Th>Rôle</Table.Th>
                    <Table.Th style={{ width: 80 }} />
                  </Table.Tr>
                </Table.Thead>
                <Table.Tbody>
                  {authorizations.map((authorization) => (
                    <Table.Tr key={authorization.id}>
                      <Table.Td
                        onClick={() =>
                          router.get(
                            `/organizations/${current_organization?.slug}/authorizations/${authorization.id}/edit`
                          )
                        }
                        style={{ cursor: 'pointer' }}
                      >
                        {authorization.user.name || '-'}
                      </Table.Td>
                      <Table.Td
                        onClick={() =>
                          router.get(
                            `/organizations/${current_organization?.slug}/authorizations/${authorization.id}/edit`
                          )
                        }
                        style={{ cursor: 'pointer' }}
                      >
                        {authorization.user.email}
                      </Table.Td>
                      <Table.Td
                        onClick={() =>
                          router.get(
                            `/organizations/${current_organization?.slug}/authorizations/${authorization.id}/edit`
                          )
                        }
                        style={{ cursor: 'pointer' }}
                      >
                        {roleOptions.find((o) => o.value === authorization.role)?.label || authorization.role}
                      </Table.Td>
                      <Table.Td>
                        <ActionIcon
                          variant="subtle"
                          color="red"
                          size="lg"
                          onClick={() => {
                            if (confirm('Êtes-vous sûr de vouloir supprimer cette autorisation ?')) {
                              router.delete(
                                `/organizations/${current_organization?.slug}/authorizations/${authorization.id}`
                              )
                            }
                          }}
                        >
                          <IconTrash size={18} />
                        </ActionIcon>
                      </Table.Td>
                    </Table.Tr>
                  ))}
                </Table.Tbody>
              </Table>
            </Table.ScrollContainer>
          </Paper>
        ) : (
          <Paper
            py={80}
            px="md"
            radius="lg"
            style={{
              border: '1px dashed var(--mantine-color-gray-3)',
              textAlign: 'center',
              backgroundColor: 'transparent',
            }}
          >
            <Stack align="center">
              <IconShieldLock size={48} color="var(--mantine-color-gray-5)" />
              <Title order={3}>Aucune autorisation trouvée</Title>
              <Text c="dimmed" size="sm">
                Invitez des membres à rejoindre votre organisation pour collaborer.
              </Text>
            </Stack>
          </Paper>
        )}
      </Stack>
    </>
  )
}
